/*常量文件*/

//每页条数
export const pageSize = 50;

//公司名称
export const companyName = "恒路传媒会展集团";

//通用启停状态
const Common_Status = [
  { Key: 1, Text: "启用" },
  { Key: 0, Text: "停用" },
];

//通用审批状态
const Common_Check_Status = [
  { Key: 0, Text: "待审核", Color: "#909399", BgColor: "#F4F6F9" },
  { Key: 1, Text: "审核通过", Color: "#00B42A", BgColor: "#E6FFEA" },
  { Key: 2, Text: "审核不通过", Color: "#F53F3F", BgColor: "#FFECEC" },
  { Key: 3, Text: "撤回", Color: "#F53F3F", BgColor: "#FFECEC" },
  { Key: 4, Text: "审核通过", Color: "#00B42A", BgColor: "#E6FFEA" }, //4表示流程跳过，前端直接显示审核通过即可
];

//图片格式后缀
const Image_Exts = ["jpg", "jpeg", "png", "gif", "bmp"];

//会议状态
const Meeting_Status = [
  { Key: 0, Text: "策划中", Color: "#845EC2", BgColor: "#F0EBFA" },
  { Key: 1, Text: "筹备中", Color: "#4A88EB", BgColor: "#EDF4FD" },
  { Key: 2, Text: "进行中", Color: "#36A35E", BgColor: "#EEF9F2" },
  { Key: 3, Text: "已结束", Color: "#E68943", BgColor: "#FFF3E8" },
  { Key: 4, Text: "已完成", Color: "#289460", BgColor: "#E8F7F0" },
  { Key: 5, Text: "核算中", Color: "#D4A028", BgColor: "#FFF9E0" },
  { Key: 6, Text: "不通过", Color: "#D94848", BgColor: "#FFE8E8" },
  { Key: 7, Text: "已核算", Color: "#747E8C", BgColor: "#F4F6F8" },
  { Key: 8, Text: "已取消", Color: "#5C6470", BgColor: "#F7F8FA" },
];

//会议操作类型
const HuiYi_CaoZuo_Type = [
  { Key: 1, Text: "实施", Color: "#1677ff", BgColor: "#e6f4ff" },
  { Key: 2, Text: "筹备", Color: "#fa8c16", BgColor: "#fff7e6" },
];

//会议日程类型
const Meeting_Schedule_Type = [
  { Key: 0, Text: "报道", Color: "#00b96b", BgColor: "#e6ffed" },
  { Key: 1, Text: "会议", Color: "#1677ff", BgColor: "#e6f4ff" },
  { Key: 2, Text: "就餐", Color: "#faad14", BgColor: "#fffbe6" },
];

//会议日程状态
const Meeting_Schedule_Status = [
  { Key: 0, Text: "未开始", Color: "#a2a2a2", BgColor: "#f6f6f6" },
  { Key: 1, Text: "进行中", Color: "#fff", BgColor: "#1e90ff" },
  { Key: 2, Text: "已结束", Color: "#fff", BgColor: "#ffa500" },
];

//会议参会员身份
const Meeting_Attend_Type = [
  { Key: 0, Text: "参会人", Color: "#00b96b", BgColor: "#e6ffed" },
  { Key: 1, Text: "嘉宾", Color: "#1677ff", BgColor: "#e6f4ff" },
];

//会议分会类型
const Meeting_Place_Type = [
  { Key: 0, Text: "主会场", Color: "#D32F2F", BgColor: "#FFEBEE" },
  { Key: 1, Text: "分会场", Color: "#0288D1", BgColor: "#E1F5FE" },
];

//到款记录状态
const BankReceipt_Status = [
  { Key: 0, Text: "未认领", Color: "#f53f3f", BgColor: "#ffe8e8" },
  { Key: 1, Text: "部分认领", Color: "#ff7d00", BgColor: "#fff2e8" },
  { Key: 2, Text: "已认领", Color: "#009f7f", BgColor: "#e6f7f2" },
  { Key: 3, Text: "已冻结", Color: "#1677ff", BgColor: "#e8f3ff" },
  { Key: 4, Text: "已作废", Color: "#595959", BgColor: "#f5f5f5" },
];

//到款认领记录状态
const BankCollected_Record_Status = [
  { Key: 0, Text: "待确认", Color: "#f53f3f", BgColor: "#ffe8e8" },
  { Key: 1, Text: "已确认", Color: "#00b42a", BgColor: "#f0fff4" },
  { Key: 2, Text: "已取消", Color: "#86909c", BgColor: "#f2f3f5" },
  { Key: 3, Text: "已撤回", Color: "#ff7d00", BgColor: "#fff7e6" },
];

//审批订单状态
const Apply_Order_Status = [
  { Key: 0, Text: "待审核", Color: "#fa8c16", BgColor: "#fffbe6" },
  { Key: 1, Text: "待支付", Color: "#1677ff", BgColor: "#e6f4ff" },
  { Key: 2, Text: "已支付", Color: "#00b42a", BgColor: "#f0fff4" },
  { Key: 3, Text: "不通过", Color: "#f5222d", BgColor: "#fff2f0" },
  { Key: 4, Text: "已取消", Color: "#8c8c8c", BgColor: "#fafafa" },
];

//审批步骤    跟上方审批订单状态联动，如果订单状态为0待审核时，则显示审批步骤，不为0则标识审批流结束
const Apply_Order_Step = [
  { Key: 0, Text: "待业务审批", Color: "#d97706", BgColor: "#fff7ed" },
  { Key: 1, Text: "待财务审批", Color: "#2563eb", BgColor: "#eff6ff" },
  { Key: 2, Text: "待总经理审批", Color: "#047857", BgColor: "#f0fdf4" },
  { Key: 3, Text: "待出纳审批", Color: "#c026d3", BgColor: "#faf5ff" },
];
//供应商预付单状态
const Supplier_PaymentApply_Status = [
  { Key: 0, Text: "待审核", Color: "#d46b08", BgColor: "#fff7e6" },
  { Key: 1, Text: "已审核", Color: "#00783e", BgColor: "#e6f7ef" },
  { Key: 2, Text: "已支付", Color: "#1d39c4", BgColor: "#e8f0fe" },
  { Key: 3, Text: "不通过", Color: "#cf1322", BgColor: "#fff1f0" },
  { Key: 4, Text: "已取消", Color: "#595959", BgColor: "#f5f5f5" },
];

//办公费用审批单状态
const Office_Expense_Apply_Status = [
  { Key: 0, Text: "待审核", Color: "#fa8c16", BgColor: "#fffbe6" },
  { Key: 1, Text: "待支付", Color: "#1677ff", BgColor: "#e6f4ff" },
  { Key: 2, Text: "已支付", Color: "#00b42a", BgColor: "#f0fff4" },
  { Key: 3, Text: "不通过", Color: "#f5222d", BgColor: "#fff2f0" },
  { Key: 4, Text: "已取消", Color: "#8c8c8c", BgColor: "#fafafa" },
];

//办公费用支付渠道
const Office_Expense_Apply_Payment_Method = [
  { Key: 0, Text: "公司报销", Color: "#d46b08", BgColor: "#fff7e6" },
  { Key: 1, Text: "乙方账户", Color: "#00783e", BgColor: "#e6f7ef" },
];

//发票类型
const Invoice_Type = [
  { Key: 1, Text: "增值税普通发票" },
  { Key: 2, Text: "增值税专用发票" },
];

//会议开票票据状态
const Meeting_Invoice_Status = [
  { Key: 0, Text: "审批中", Color: "#8B5CF6", BgColor: "#F5F1FF" },
  { Key: 1, Text: "开票中", Color: "#2563EB", BgColor: "#EFF6FF" },
  { Key: 2, Text: "已开票", Color: "#059669", BgColor: "#ECFDF5" },
  { Key: 3, Text: "已到账", Color: "#D97706", BgColor: "#FFFBEB" },
  { Key: 4, Text: "已红冲", Color: "#0D9488", BgColor: "#F0FDFA" },
  { Key: 5, Text: "已作废", Color: "#B45309", BgColor: "#FFF7ED" },
  { Key: 6, Text: "不通过", Color: "#DC2626", BgColor: "#FEF2F2" },
  { Key: 7, Text: "已取消", Color: "#4B5563", BgColor: "#F3F4F6" },
];

//发票管理界面中的发票状态            //返回开票中、已开票、已到款、已红冲、已作废
const Invoice_Status = Meeting_Invoice_Status.filter((w) =>
  [1, 2, 3, 4, 5].includes(w.Key),
);

//交通方式
const Meeting_Transport_Ticket_Type = [
  { Key: 1, Text: "火车", Color: "#2563EB", BgColor: "#EFF6FF" },
  { Key: 2, Text: "飞机", Color: "#059669", BgColor: "#ECFDF5" },
];

//行程类型
const Meeting_Transport_Trip_Type = [
  { Key: 1, Text: "来程", Color: "#2563EB", BgColor: "#EFF6FF" },
  { Key: 2, Text: "返程", Color: "#059669", BgColor: "#ECFDF5" },
];

//交通票据状态：0未出票 1已出票 2已改签 3已退票 4已取消
const Meeting_Transport_Ticket_Status = [
  { Key: 0, Text: "未出票", Color: "#a2a2a2", BgColor: "#fff" },
  { Key: 1, Text: "已出票", Color: "#fff", BgColor: "#1e90ff" },
  { Key: 2, Text: "已改签", Color: "#fff", BgColor: "#ffa500" },
  { Key: 3, Text: "已退票", Color: "#fff", BgColor: "#f00" },
  { Key: 4, Text: "已取消", Color: "#fff", BgColor: "#e2e2e2" },
];

//接送类型（1：接机/站，2：送机/站，3：市内接送，4：属地交通）
const Meeting_Pickup_Car_Type = [
  { Key: 1, Text: "接机/站", Color: "#666", BgColor: "#fff" },
  { Key: 2, Text: "送机/站", Color: "#2B7BED", BgColor: "#fff" },
  { Key: 3, Text: "市内接送", Color: "#F29928", BgColor: "#fff" },
  { Key: 4, Text: "属地交通", Color: "#E54848", BgColor: "#fff" },
];

//按钮对应的可操作状态
const btn_status = {
  发票管理: {
    开票: [1], //状态为：开票中
    标记到款: [2], //状态为：已开票
    查看: [3, 4, 5], //状态为：已到款、已红冲、已作废
    作废: [2, 3], //状态为：已开票
    红冲: [2, 3], //状态为：已开票
  },
};

export default {
  Image_Exts,
  Common_Status,
  Meeting_Status,
  HuiYi_CaoZuo_Type,
  Meeting_Schedule_Type,
  Meeting_Schedule_Status,
  Meeting_Attend_Type,
  Meeting_Place_Type,
  BankReceipt_Status,
  BankCollected_Record_Status,
  Supplier_PaymentApply_Status,
  Common_Check_Status,
  Office_Expense_Apply_Status,
  Office_Expense_Apply_Payment_Method,
  Apply_Order_Status,
  Apply_Order_Step,
  Invoice_Type,
  Meeting_Invoice_Status,
  Invoice_Status,
  btn_status,
  Meeting_Transport_Ticket_Type,
  Meeting_Transport_Trip_Type,
  Meeting_Transport_Ticket_Status,
  Meeting_Pickup_Car_Type,
};
